"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var react_lazyload_1 = require("react-lazyload");
var url_1 = require("utils/url");
var styles = require("./index.scss");
var banner_1 = require("utils/playground/banner");
var dataImageRegex = /^data:image/;
var Image = (function (_super) {
    __extends(Image, _super);
    function Image(props) {
        var _this = _super.call(this, props) || this;
        _this.transferImageSrc = function () {
            var _a = _this.props, src = _a.src, params = _a.params, aliSize = _a.aliSize;
            return url_1.compatibleProtocolLessUrl(url_1.transferAlisize(url_1.compatibleWebpImage(url_1.compatibleQiniuAndGeneralImage(src, params)), aliSize));
        };
        _this.updateImageSrc = function (useOriginSrc) {
            var src = _this.props.src;
            if (!src) {
                return;
            }
            if (dataImageRegex.test(src)) {
                return _this.setState({ imageSrc: src });
            }
            _this.setState({
                useOriginSrc: !!useOriginSrc,
                imageSrc: useOriginSrc ? src : _this.transferImageSrc()
            });
        };
        _this.onImageLoad = function (event) {
            try {
                _this.props.onImgLoad(event.target.naturalWidth, event.target.naturalHeight);
                if (event.target.naturalWidth <= 1) {
                    _this.onImageFailedLoad();
                }
            }
            catch (err) { }
        };
        _this.onImageFailedLoad = function () {
            if (!_this.state.useOriginSrc) {
                _this.updateImageSrc(true);
            }
        };
        _this.state = {
            useOriginSrc: false,
            imageSrc: props.src
        };
        return _this;
    }
    Image.prototype.componentDidMount = function () {
        this.updateImageSrc();
    };
    Image.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.src !== nextProps.src) {
            this.updateImageSrc();
        }
    };
    Image.prototype.render = function () {
        var _this = this;
        var _a = this.props, isLazyLoad = _a.isLazyLoad, defaultSrc = _a.defaultSrc, className = _a.className, style = _a.style, src = _a.src, aliSize = _a.aliSize, params = _a.params, extra = __rest(_a, ["isLazyLoad", "defaultSrc", "className", "style", "src", "aliSize", "params"]);
        var imageSrc = this.state.imageSrc;
        var imgProps = __assign({ className: className,
            style: style }, extra);
        var placeholderEle = (React.createElement("img", __assign({ src: defaultSrc }, imgProps, { className: classnames_1.default(styles.placeholder, className) })));
        if (!src) {
            return placeholderEle;
        }
        var height, width;
        if (style) {
            height = style.height;
            width = style.width;
        }
        return isLazyLoad ? (React.createElement(react_lazyload_1.default, { height: height, once: true, offset: 100, placeholder: placeholderEle },
            React.createElement("img", __assign({ src: imageSrc, onLoad: this.onImageLoad, onError: function () { return imageSrc && _this.onImageFailedLoad(); } }, imgProps, { "data-load-type": "lazy" })))) : (React.createElement("img", __assign({ src: imageSrc, onLoad: this.onImageLoad, onError: function () { return imageSrc && _this.onImageFailedLoad(); } }, imgProps, { width: width, height: height, "data-load-type": "normal" })));
    };
    Image.defaultProps = {
        alt: "",
        isLazyLoad: false,
        aliSize: 0,
        defaultSrc: banner_1.GetEmptyImage(),
        params: "imageView2/2/w/300"
    };
    return Image;
}(React.PureComponent));
exports.default = Image;
